export default {
  'app.network.offline':
    'You are currently offline. Some features may be unavailable.',
  'app.error.chunk.title': 'Failed to load page',
  'app.error.chunk.description.offline':
    'Your network connection has been lost. Please check your connection and reload.',
  'app.error.chunk.description.online':
    'Page resources failed to load. Please reload and try again.',
  'app.error.render.title': 'Something went wrong',
  'app.error.render.description':
    'Sorry, an error occurred on this page. Please reload or go back to the home page.',
  'app.error.retry': 'Retry',
  'app.error.reload': 'Reload Page',
  'app.error.home': 'Back Home',
  'app.request.offline':
    'Network unavailable. Please check your connection and try again.',
};
